import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="bg-white text-gray-800">
            <div className="max-w-6xl mx-auto px-4 py-16">
                <h2
                    className="text-4xl font-bold text-center text-yellow-600 mb-12"
                    data-aos="fade-down"
                >
                    Contact Us
                </h2>
                <div className="grid md:grid-cols-2 gap-8" data-aos="fade-up">
                    <div>
                        <h3 className="text-2xl font-semibold mb-4 text-yellow-800">AXS Enterprises</h3>
                        <p className="mb-2">Formed in 2024, doing business worldwide.</p>
                        <p className="mb-2">Phone: <a href="tel:9990404922" className="text-yellow-700">9990404922</a></p>
                        <p className="mb-2">Address: Uttam Nagar, Delhi, India</p>
                        <img
                            src="https://images.unsplash.com/photo-1581091870622-ffb7dbf6cdcf"
                            alt="AXS Office"
                            className="rounded-lg mt-6 shadow-md w-full h-64 object-cover"
                        />
                    </div>

                    <form className="bg-yellow-50 p-6 rounded-xl shadow-md">
                        <div className="mb-4">
                            <label className="block mb-1 font-medium">Name</label>
                            <input
                                type="text"
                                placeholder="Your Name"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-yellow-500"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1 font-medium">Email</label>
                            <input
                                type="email"
                                placeholder="you@example.com"
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-yellow-500"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block mb-1 font-medium">Message</label>
                            <textarea
                                rows="4"
                                placeholder="Your message..."
                                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-yellow-500"
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-yellow-600 text-white font-semibold py-2 rounded-md hover:bg-yellow-700 transition"
                        >
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contact;
